import * as React from "react"
const MenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={19}
    fill="none"
    {...props}
  >
    <path
      fill="#A1A1A1"
      d="M3.5 4.5h11v2h-11zM3.5 8.5h8v2h-8zM12.5 8.5h2v2h-2zM3.5 12.5h11v2h-11z"
    />
  </svg>
)
export default MenuIcon
